// Do not optimize this import because it causes circular injection
import { EIIState } from 'app/shared/enums/international-invoice.enums';
import {
  collatorCompare,
  compareByNestedKey,
  compareNumbers,
  compareStringDates,
  compareStrings,
  compareStringWithoutRegister,
} from '@shared';
import { Invoice } from '@models';
import { getRecipient, getStatus, getStatusComment } from './invoices-my-international.helpers';

export const INVOICE_STATE_MAP: Record<EIIState, { status: string, statusComment: string }> = {
  [EIIState.IEW]: { status: 'Відправлено', statusComment: 'Переглядайте деталі міжнародного відправлення в розділі «Мої посилки»' },
  [EIIState.CLOSED]: { status: 'Отримано', statusComment: 'Переглядайте деталі міжнародного відправлення в розділі «Мої посилки»' },
  [EIIState.REQUEST]: { status: 'Заявка', statusComment: 'Очікує на верифікацію' },
  [EIIState.UPDATED]: { status: 'Оновлена', statusComment: 'Очікує на верифікацію' },
  [EIIState.VERIFIED]: { status: 'Верифіковано', statusComment: 'Готово до відправки' },
  [EIIState.NOT_VERIFIED]: { status: 'Не верифіковано', statusComment: '' },
}

export const DEFAULT_SUBSTATE = 'Інше';

export const CONTACT_COMMENT = `Потребує уточнення. Зв'яжіться з нами за телефоном 0443500544, 0678300544`;


export const ZEBRA_ALLOWED_PRINT_STATES: EIIState[] = [
  EIIState.VERIFIED,
];

export enum EPaymentInfoSource {
  API = 'API',
  CACHE = 'CACHE',
}

export const InternationalInvoiceDisplayColumns = [
  'select',
  'docNumber',
  'scanSheetNumber',
  'date',
  'CountryRecipientDescription',
  'dateDelivery',
  'cost',
  'description',
  'price',
  'weight',
  'amount',
  'backDelivery',
  'paymentControl',
  'barcode',
  'receiver',
  'receiverPhone',
  'receiverCity',
  'address',
  'payerType',
  'options',
];

export const InternationalInvoiceColsConf = [
  {
    name: 'Номер реєстру',
    show: true,
    class: 'scanSheetNumber',
  },
  {
    name: 'Дата створення',
    show: true,
    class: 'date',
  },
  {
    name: 'Оголошена цінність',
    show: true,
    class: 'cost',
  },
  {
    name: 'Вартість доставки',
    show: true,
    class: 'price',
  },
  {
    name: 'Кількість місць',
    show: true,
    class: 'amount',
  },
  {
    name: 'Внутрішній номер',
    show: true,
    class: 'OrderNumber',
  },
  {
    name: 'Опис вiдправлення',
    show: true,
    class: 'description',
  },
  {
    name: 'Отримувач',
    show: true,
    class: 'receiver',
  },
  {
    name: 'Телефон отримувача',
    show: true,
    class: 'receiverPhone',
  },
  {
    name: 'Країна отримувача',
    show: true,
    class: 'CountryRecipientDescription',
  },
  {
    name: 'Місто отримувача',
    show: true,
    class: 'receiverCity',
  },
  {
    name: 'Адреса отримання',
    show: false,
    class: 'address',
  },
  {
    name: 'Тип доставки',
    show: true,
    class: 'delivery',
  },
  {
    name: 'Статус заявки',
    show: true,
    class: 'status',
  },
  {
    name: 'Коментар до статусу',
    show: true,
    class: 'statusComment',
  },
  {
    name: 'Дата та час останнього редагування',
    show: true,
    class: 'editDate',
  },
];

export const InternationalInvoiceSortConf = {
  docNumber: compareByNestedKey(compareNumbers, 'Number'),
  amount: compareByNestedKey(compareNumbers, 'PlacesAmount'),
  date: compareByNestedKey(compareStringDates, 'CreationDate'),
  editDate: compareByNestedKey(compareStringDates, 'DateTime'),
  receiverPhone: compareByNestedKey(compareNumbers, 'PhoneRecipient'),
  CountryRecipientDescription: compareByNestedKey(compareStrings, 'CountryRecipientDescription'),
  receiverCity: compareByNestedKey(
    compareStringWithoutRegister,
    'CityRecipient',
  ),
  address: compareByNestedKey(compareStrings, 'AddressRecipient'),
  scanSheetNumber: compareByNestedKey(compareStrings, 'ScanSheetNumber'),
  status: (a: Invoice, b: Invoice, isAsc: boolean) =>
    compareStrings(getStatus((a as any).State), getStatus((b as any).State), isAsc),
  receiver: (a: Invoice, b: Invoice, isAsc: boolean) =>
    compareStrings(getRecipient(a), getRecipient(b), isAsc),
  statusComment: (a: Invoice, b: Invoice, isAsc: boolean) => compareStrings(
    getStatusComment((a as any)?.State, (a as any)?.SubStateDocument),
    getStatusComment((b as any)?.State, (b as any)?.SubStateDocument),
    isAsc,
  ),
  OrderNumber: compareByNestedKey(collatorCompare, 'OrderNumber'),
  delivery: compareByNestedKey(compareStrings, 'DeliveryTypeDescription'),
  description: compareByNestedKey(compareStrings, 'CargoDescription'),
  cost: compareByNestedKey(compareNumbers, 'Cost'),
  price: compareByNestedKey(compareNumbers, 'DocumentCost'),
};
